<script setup lang="ts">
import MapDownloadModal from '@/components/setting/offline/MapDownloadModal.vue'
import { useDisasterStore } from '@/stores/disasterStore'
import { useGovernmentSettingStore } from '@/stores/governmentSettingStore'
import { ref, computed, watch, onMounted } from 'vue'
import { useHoldTemporaryStore } from '@/stores/holdTemporaryStore'
import CommonModal from '@/components/common/dialog/CommonModal.vue'
import { useCommonModalStore } from '@/stores/commonModalStore'
import { useMiiaFwStore } from '@/stores/miiaFwStore'

const governmentSettingStore = useGovernmentSettingStore()
const disasterStore = useDisasterStore()
const holdTemporaryStore = useHoldTemporaryStore()
const commonModalStore = useCommonModalStore()
const miiaFwStore = useMiiaFwStore()

const mapDownloadModalRef = ref<InstanceType<typeof MapDownloadModal> | null>(null)

// マップダウンロードモーダルを開く
const openMapDownloadModal = () => {
  mapDownloadModalRef.value!.openModal()
}

const isAuthenticated = computed(() => {
  if (!governmentSettingStore.isLoaded) return false
  if (!disasterStore.disaster) return false
  if (!miiaFwStore.isPermitted) return false
  if (!governmentSettingStore.getGovernmentSetting.isDeviceAuthentication) return true
  return holdTemporaryStore.deviceInfo.permissionStatus === 'allow'
})

watch(
  isAuthenticated,
  newValue => {
    if (!newValue) return
    // 無償版の場合はオフライン機能は使用しないため、返却
    if (governmentSettingStore.getGovernmentSetting.serviceLimitEnable) return
    // ver1.2 初回ログイン時のみ
    if (window.localStorage.getItem('availableOfflineMap') == null) {
      window.localStorage.setItem('availableOfflineMap', '0')
      commonModalStore
        .openConfirmModal({
          title: 'オフライン地図を設定しますか？',
          body: 'オフライン地図が利用できます。<br>設定しますか?<br>※設定はいつでも可能です。',
          okTitle: 'はい',
          cancelTitle: 'いいえ'
        })
        .then(() => {
          mapDownloadModalRef.value!.openModal()
        })
    }
  },
  {
    immediate: true
  }
)

onMounted(() => {})
defineExpose({
  openMapDownloadModal
})
</script>

<template>
  <div>
    <MapDownloadModal ref="mapDownloadModalRef" />
    <CommonModal />
  </div>
</template>
